import { styled } from "@mui/material";

export const SeismicOverlayList = styled("div")(`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  overflow-y: auto;
  padding: 12px;
`);

export const SeismicOverlayListItem = styled("div")(`
  background: white;
  border-radius: 4px;
  padding: 4px 8px;
  scroll-behaviour: smooth;
`);

export const SeismicOverlayListItemHeader = styled("div")(`
  align-items: top;
  cursor: pointer;
  display: grid;
  gap: 8px;
  grid-template-columns: max-content 1fr 30px;
`);

export const SeismicOverlayListItemHeaderStack = styled("div")(`
  align-items: center;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  gap: 4px;
`);

export const SeismicOverlayListItemHeaderInfo = styled("div")(`
  font-size: 12px;
  line-height: 16px;
`);

export const SeismicOverlayListItemHeaderInfoLocation = styled("div")(
  ({ theme }) => `
  color: ${theme.palette.text.secondary};
`,
);

export const SeismicOverlayListItemHeaderColor = styled("span")(`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: inline-block;
  height: 16px;
  width: 16px;
`);

export const SeismicOverlayListItemBody = styled("div")(`
  display: grid;
  font-size: 12px;
  gap: 2px 16px;
  grid-template-columns: max-content 1fr;
  line-height: 15px;
  margin-top: 8px;
`);
